// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Alert_wrap__2S4Q2"};